<script>
/**
 * This component allows us to use the runtime version of vuejs (as opposed to the full version).
 * Previously, we needed to compile a template string found in front.blade.php. By moving
 * this inline template to a vue SFC, we can now compile this once at build time and no longer need the full version.
 */
export default {
  name: "App",
};
</script>

<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view name="modal" />
    </transition>

    <notifications
      position="top right"
      width="auto"
    >
      <template
        slot="body"
        slot-scope="{ item, close }"
      >
        <div
          class="vnotif _notify_legacy"
          :class="item.type"
          role="alert"
          @click="close"
        >
          <div class="vnotif-content">
            <div class="flex-center">
              <i
                v-if="item.type == 'error'"
                class="fa-solid fa-times-circle"
              />
              <i
                v-if="item.type == 'info'"
                class="fa-solid fa-info-circle"
              />
              <i
                v-if="item.type == 'success'"
                class="fa-solid fa-check-circle"
              />
              <i
                v-if="item.type == 'warning'"
                class="fa-solid fa-circle-exclamation"
              />
              <div
                v-if="item.title"
                class="vnotif-title ml-1"
                v-html="item.title"
              />
            </div>
            <div
              class="vnotif-content"
              v-html="item.text"
            />
          </div>
          <div class="vnotif-close">
            <i class="fa fa-times" />
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>
